








































/* eslint-disable class-methods-use-this */
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageError404 extends Vue {
  goBack() {
    this.$router.push({
      name: 'home',
    });
  }

  mounted() {
    document.body.classList.add('page-login', 'background', 'show-spinner', 'no-footer', 'rounded');
  }

  beforeDestroy() {
    document.body.classList.remove('page-login', 'background', 'show-spinner', 'no-footer', 'rounded');
  }
}
